
import { useStore } from "vuex"
import { computed, defineComponent } from "vue";
import GenericButton from "../GenericButton.vue";
import { getGearImage } from "@/data/gear-utils";
export default defineComponent({
 name: "GearButton",
 components: {GenericButton},
 props: {
  item: {
    type: Object,
    default: () => ({})
  },
  gearSlot: {
    type: String,
    default: ''
  },
  itemIndex: {
    type: Number,
    default: 0
  },
 },
 emits: ['resetView'],
 setup(props, context) {
    const store = useStore();

    const craftItem = (item: any) => {
      store.dispatch('setItemForCrafting', item)
      store.dispatch('toggleCraftMenu')
    };

    const equipItem = (slot: string, key: string, item: any = undefined) => {
      const data = {
        slot,
        key,
        item
      }
      store.dispatch('handleIncomingCommand', {
        command: 'equipItem',
        data: data
      });
      context.emit('resetView');
    };
    
    const isEquipped = computed(() => {
      return store.state.build.EquippedGear[props.gearSlot]?.image === props.item.image;
    });

    return {
      state: store.state,
      getGearImage,
      craftItem,
      equipItem,
      isEquipped,
   }
 },
})
